module.exports = __webpack_public_path__ + "img/man.ca1c6c83.png";